import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

const PAGE_SIZE = 10;

export function mapClient(snap) {
  return { id: snap.id, ...snap.data() };
}

/**
 * Clientes del tenant + catálogo GLOBAL (mismo criterio que ClienteScreen).
 */
export async function listClients({ ruc, pageSize = PAGE_SIZE, cursor = null, search = '' }) {
  if (!ruc) throw new Error('RUC requerido');
  const base = [where('ruc', 'in', [ruc, 'GLOBAL'])];

  if (search) {
    const term = search.trim().toLowerCase();
    const q = query(collection(db, 'clientes'), ...base, limit(pageSize * 3));
    const snap = await getDocs(q);
    const items = snap.docs
      .map(mapClient)
      .filter((c) => {
        const docNo = String(c.nroDocumento || '').toLowerCase();
        const name = String(c.razonSocial || c.nombre || c.nombreComercial || '').toLowerCase();
        return docNo.includes(term) || name.includes(term);
      })
      .slice(0, pageSize);
    return { items, cursor: null, hasMore: false };
  }

  const q = cursor
    ? query(collection(db, 'clientes'), ...base, orderBy('nroDocumento'), startAfter(cursor), limit(pageSize))
    : query(collection(db, 'clientes'), ...base, orderBy('nroDocumento'), limit(pageSize));

  const snap = await getDocs(q);
  const last = snap.docs[snap.docs.length - 1] || null;
  return {
    items: snap.docs.map(mapClient),
    cursor: last,
    hasMore: snap.docs.length === pageSize,
  };
}

export async function getClient(id) {
  const snap = await getDoc(doc(db, 'clientes', id));
  if (!snap.exists()) throw new Error('Cliente no encontrado');
  return mapClient(snap);
}

/** Mismo payload que usa la app móvil en ClienteScreen. */
function buildClientPayload({ tipoDocumento, nroDocumento, nombre, razonSocial, direccion, ubigueo, telefono, email, ruc }) {
  const payload = {
    tipoDocumento,
    nroDocumento: String(nroDocumento || '').trim(),
    direccion: direccion || '',
    ubigueo: ubigueo || '',
    ruc,
  };
  if (tipoDocumento === 'DNI') {
    payload.nombre = nombre || '';
  } else if (tipoDocumento === 'RUC') {
    payload.razonSocial = razonSocial || '';
    payload.nombreComercial = razonSocial || '';
  }
  if (telefono) payload.telefono = telefono;
  if (email) payload.email = email;
  return payload;
}

export async function createClient({ ruc, data }) {
  if (!ruc) throw new Error('RUC requerido');
  if (!data?.tipoDocumento || !data?.nroDocumento) {
    throw new Error('Tipo y número de documento son obligatorios.');
  }
  if (data.tipoDocumento === 'DNI' && !data.nombre) {
    throw new Error('El nombre es obligatorio para DNI.');
  }
  if (data.tipoDocumento === 'RUC' && !data.razonSocial) {
    throw new Error('La razón social es obligatoria para RUC.');
  }
  return addDoc(collection(db, 'clientes'), {
    ...buildClientPayload({ ...data, ruc }),
    createdAt: new Date().toISOString(),
  });
}

export async function updateClient(id, { ruc, data }) {
  await updateDoc(doc(db, 'clientes', id), buildClientPayload({ ...data, ruc }));
}
